const createErrorStore = (set) => ({
  error: null,
  setError: (value) => set(() => ({ error: value })),
  resetError: () => set(() => ({ error: null })),
});
export default createErrorStore;
